import { FunctionComponent } from "react";

import Image from "@ui/components/media/Image/Image";
import CommunityLogo from "@ui/components/notifications/CommunityLogo/CommunityLogo";
import {
  AnyNotification,
  ExternalUserProfile,
} from "@voxmedia/duet-context/context/notifications-context";

import * as styles from "./Avatar.css";

export type AvatarSize = "small" | "large";

interface AvatarProps {
  notification: AnyNotification;
  fromProfile: ExternalUserProfile;
  showCommunityLogo?: boolean;
  avatarSize?: AvatarSize;
}

const Avatar: FunctionComponent<AvatarProps> = ({
  notification,
  fromProfile,
  showCommunityLogo = true,
  avatarSize = "large",
}) => {
  return (
    <div className={styles.avatarContainer[avatarSize]}>
      {fromProfile.avatarUrl ? (
        <Image
          src={fromProfile.avatarUrl}
          alt={fromProfile.username}
          className={styles.avatarImage}
        />
      ) : fromProfile.username && fromProfile.username[0] ? (
        <div className={styles.avatarFallback[avatarSize]}>
          {fromProfile.username[0].toUpperCase()}
        </div>
      ) : null}
      {showCommunityLogo && (
        <CommunityLogo notification={notification} alignment="bottom-right" />
      )}
    </div>
  );
};

export default Avatar;
